// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".partner-software-datagrid .key-prefix {\n  font-family: monospace;\n  font-size: 0.9em;\n}", "",{"version":3,"sources":["webpack://./src/components/PartnerSoftwareDataGrid/index.scss"],"names":[],"mappings":"AACE;EACE,sBAAA;EACA,gBAAA;AAAJ","sourcesContent":[".partner-software-datagrid {\n  .key-prefix {\n    font-family: monospace;\n    font-size: 0.9em;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
